angular.module('wbDashboard').controller('SecurityUpdateControllerAurea',
    ['$scope', '$state', '$timeout', '$uibModal', '$q', 'User', 'Request', 'Misc', 'Message', 'Display',
function ($scope, $state, $timeout, $uibModal, $q, User, Request, Misc, Message, Display) {

    $scope.forms = {};
    $scope.pageData = {
        oldPhone: null,
        axosIdentity: null,
        firstPage: null,
        complete: false
    };
    $scope.data = {};

    $scope.validation = Misc.validation;

    $scope.pages = ['overview', 'credentials-confirm', 'username-confirm', 'password-update', 'number-confirm', 'number-update', 'success']; // 'invite'

    Display.setMenu(false);

    if ($scope.$stateParams.page !== 'overview') {
        $timeout(function() {
            $scope.goToPage('overview');
        });
    }

    $scope.$watch(User.getDetail, function(detail) {
        if (detail) {
            $scope.pageData.oldPhone = detail.detail.phone;
        }
    });

    $scope.checkStatus = function() {
        $scope.pageData.sending = true;
        return Request.make("security_migrate_status").then(function(response) {
            if (response.data) {
                if (response.data.already_migrated) {
                    $scope.goOverview();
                }

                $scope.pageData.axosIdentity = response.data.has_axos_identity;
                $scope.pageData.firstPage = $scope.pageData.axosIdentity ? "credentials-confirm" : "username-confirm";
                $scope.axosUsernames = response.data.axos_usernames;
                if ($scope.axosUsernames && $scope.axosUsernames.length === 1) {
                    $scope.data.username = $scope.axosUsernames[0];
                }
            }

        }).catch(function (err) {
            throw err;
        }).finally(function () {
            $scope.pageData.sending = false;
        });
    };
    $scope.checkStatus();

    $scope.verifyCredentials = function() {
        var data = {
            username: $scope.data.username,
            password: $scope.data.password,
        };
        $scope.pageData.sending = true;

        return Request.make("security_migrate_verify", data).then(function(response) {
            $scope.pageData.complete = true;
            $scope.goToPage('success');
        }).catch(function (response) {
            var msg = "Username or password invalid";
            if (response.data && response.data.message) {
                msg = response.data.message;
            }
            Message.set({
                "text" : msg,
                "type" : "warning"
            });
        }).finally(function () {
            $scope.pageData.sending = false;
        });
    };

    $scope.checkUsername = function() {
        var data = {
            username: $scope.data.username
        };
        $scope.pageData.sending = true;

        return Request.make("user_name_verify", data).then(function(response) {
            $scope.goNextPage('password-update');
        }).catch(function (response) {
            var msg = "That username is not available.";
            try {
                msg = response.data.details[0].message;
            } catch (e) {}
            Message.set({
                "text" : msg,
                "type" : "warning"
            });
        }).finally(function () {
            $scope.pageData.sending = false;
        });
    };

    $scope.submit = function() {
        var data = {
            phone: $scope.data.phone || $scope.pageData.oldPhone,
            username: $scope.data.username,
            password: $scope.data.password,
        };
        $scope.pageData.sending = true;
        $scope.pageData.errorMsg = null;

        return $q.when().then(function() {
            if ($scope.pageData.axosIdentity) {
                return true;
            } else {
                return Request.make("security_migrate", data);
            }

        }).then(function(response) {
            $scope.pageData.complete = true;
            $scope.goToPage('success');
        }).catch(function (response) {
            Message.set({
                "text" : "There was an issue updating your security features.",
                "type" : "warning"
            });
        }).finally(function () {
            $scope.pageData.sending = false;
        });

    };

    $scope.goNextPage = function(nextPage) {
        var currentPage = $scope.$stateParams.page;
        var pageIndex = $scope.pages.indexOf(currentPage);

        if (!nextPage) {
            nextPage = $scope.pages[pageIndex + 1];
        }

        nextPage = $scope.beforePage(nextPage);

        if (nextPage) {
            $scope.goToPage(nextPage);
        }

    };

    $scope.beforePage = function(page) {
        var nextPage = page;
        var pageIndex = $scope.pages.indexOf(page);

        switch (nextPage) {
            case 'success':
                $scope.submit();
                nextPage = null;
                break;
            default:
                break;
        }
        if (nextPage !== page) {
            nextPage = $scope.beforePage(nextPage);
        }
        return nextPage;
    };

    $scope.goToPage = function(page) {
        if (page) {
            $scope.$state.go(".", {page: page});
        }
    };

    $scope.goOverview = function() {
        $scope.goOverview.leaving = true;
        Display.setMenu(true);
        angular.element("html, body").scrollTop(0);
        $scope.$state.go('base.overview').then(function() {
            $scope.initDisplay();
        });
    };

    var transitionDeregisterHook = $scope.$transitions.onBefore({ to: 'base.**' }, function(trans) {
        var to = trans.to();
        var toParams = trans.params('to');

        if (!$scope.pageData.complete && to.name !== 'base.security-update') {
            //prevent navigating away before complete
            return false;
        }
        if ($scope.pageData.complete && to.name !== 'base.security-update') {
            //just in case page is left without clicking final leave button
            if (!$scope.goOverview.leaving) {
                $scope.goOverview();
            }
        }
        if ($scope.pageData.complete && to.name === 'base.security-update' && toParams.page !== 'success') {
            //prevent back after submitted
            return false;
        }
    });
    $scope.$on('$destroy', function() {
        transitionDeregisterHook();
    });

}]);
